import React, { useState } from 'react';
import Header from '../components/Header';
import FooterSection from '../components/FooterSection';

const ContactPage: React.FC = () => {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    try {
      const res = await fetch('https://formspree.io/f/mgvkpygp', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: data,
      });

      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Header selectedTab="" onTabChange={() => {}} />

      <main className="flex-grow px-6 py-24 max-w-screen-md mx-auto text-right" dir="rtl">
        <h1 className="text-4xl font-extrabold mb-8">ارتباط با ما</h1>

        <p className="text-lg leading-relaxed mb-6 text-neutral-300">
          برای دریافت اطلاعات بیشتر، ارائه بازخورد، یا همکاری با تیم دی‌پ‌تک، خوشحال می‌شویم با ما تماس بگیرید.
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block mb-1 text-sm">نام کامل</label>
            <input
              type="text"
              name="name"
              required
              className="w-full p-3 rounded-lg bg-white text-black"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm">ایمیل</label>
            <input
              type="email"
              name="email"
              required
              className="w-full p-3 rounded-lg bg-white text-black"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm">پیام</label>
            <textarea
              name="message"
              rows={5}
              required
              className="w-full p-3 rounded-lg bg-white text-black"
            />
          </div>
          <button
            type="submit"
            className="bg-white text-black font-bold px-6 py-3 rounded-lg hover:bg-neutral-200 transition-all"
          >
            ارسال پیام
          </button>
        </form>

        {/* پیام وضعیت */}
        {status === 'success' && (
          <p className="mt-6 text-green-400 font-bold">پیام شما با موفقیت ارسال شد.</p>
        )}
        {status === 'error' && (
          <p className="mt-6 text-red-400 font-bold">ارسال پیام با خطا مواجه شد. لطفاً دوباره تلاش کنید.</p>
        )}

        {/* اطلاعات تماس (الزامی برای تایید خطوط خدماتی) */}
        <div className="mt-12 text-sm text-neutral-300 space-y-2">
          <p><span className="font-bold">شماره تماس:</span> 02532802756 | 09053967532</p>
          <p><span className="font-bold">آدرس:</span> استان قم، شهر قم، امام خمینی، کوچه عابدی، بن بست بن بهرامی، طبقه 1، کد پستی 3719986937</p>
          <p><span className="font-bold">ایمیل:</span> info@dptek.ir</p>
        </div>
      </main>

      <FooterSection />
    </div>
  );
};

export default ContactPage;
